
import React, { useState, useEffect } from 'react';
import { Container, Typography, Button } from '@mui/material';
import axios from 'axios';

const SentenceFormation = ({ word, onNext }) => {
  const [sentenceStructure, setSentenceStructure] = useState([]);
  const [arabicTranslation, setArabicTranslation] = useState('');
  const [userSentence, setUserSentence] = useState('');
  const [isCorrect, setIsCorrect] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchSentenceStructure = async () => {
      const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
      const url = 'https://api.openai.com/v1/chat/completions';

      try {
        const response = await axios.post(
          url,
          {
            model: 'gpt-3.5-turbo',
            messages: [
              { role: 'system', content: 'You are a language assistant.' },
              {
                role: 'user',
                content: `Create a simple English sentence using the word "${word}", and provide its Arabic translation. Return the English sentence as a list of words separated by commas, and then return the Arabic translation.`,
              },
            ],
            max_tokens: 100,
            n: 1,
            stop: null,
            temperature: 0.7,
          },
          {
            headers: {
              'Authorization': `Bearer ${apiKey}`,
              'Content-Type': 'application/json',
            },
          }
        );

        const responseData = response.data.choices[0].message.content;
        const [englishSentence, arabicSentence] = responseData.split('\n');

        setSentenceStructure(englishSentence.split(','));
        setArabicTranslation(arabicSentence.trim());
      } catch (error) {
        console.error('Error fetching sentence structure from GPT:', error.response ? error.response.data : error.message);
        setSentenceStructure(['I', 'want', 'to', 'order']); // Default fallback
        setArabicTranslation('أريد أن أطلب');
      }
    };

    fetchSentenceStructure();
  }, [word]);

    const handleListen = () => {
        const utterance = new SpeechSynthesisUtterance(sentenceStructure.join(' '));
        console.log(utterance);

        utterance.lang = 'en-US';

        const voices = window.speechSynthesis.getVoices();
      
        // Directly set the voice using the name
        const googleVoice = voices.find(voice => voice.name === 'Google US English');
        
        if (googleVoice) {
          utterance.voice = googleVoice;
        }
      
        speechSynthesis.speak(utterance);
    };

  const handleSpeechRecognition = () => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript.trim().split(' ');
      setUserSentence(transcript.join(' '));

      if (JSON.stringify(transcript) === JSON.stringify(sentenceStructure)) {
        setError(false);
        setIsCorrect(true);
      } else {
        setIsCorrect(false);
        setError(true);
      }
    };

    recognition.start();
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        كون جملة باستخدام الكلمة "{word}"
      </Typography>

      <Typography variant="h6" style={{ marginBottom: '10px' }}>
        {arabicTranslation}
      </Typography>

      <Typography variant="h6" style={{ marginTop: '20px', marginBottom: '20px', color: 'green' }}>
        {sentenceStructure.join(' ')}
      </Typography>

      <Button variant="contained" color="secondary" onClick={handleSpeechRecognition} style={{ marginBottom: '20px', marginRight: '10px' }}>
        قل الجملة
      </Button>
      <Button variant="contained" color="primary" onClick={handleListen} style={{ marginBottom: '20px' }}>
        استمع إلى الجملة
      </Button>

      <Typography variant="h6" style={{ marginTop: '20px', marginBottom: '20px', color: isCorrect ? 'green' : 'black' }}>
        {userSentence}
      </Typography>
      {isCorrect && (
        <Typography variant="body1" style={{ color: 'green', marginBottom: '20px' }}>
          صحيح! لقد قلتها بشكل صحيح
        </Typography>
      )}
      {/* {error && (
        <Typography variant="body1" style={{ color: 'red', marginBottom: '20px' }}>
          خطأ حاول مرة أخرى
        </Typography>
      )} */}
      <hr />
      <Button variant="contained" color="primary" onClick={onNext}>
        المتابعة
      </Button>
    </Container>
  );
};

export default SentenceFormation;
